import { render, staticRenderFns } from "./UnidadeConservacaoPi.vue?vue&type=template&id=6ae2909f&lang=pug"
import script from "./UnidadeConservacaoPi.vue?vue&type=script&lang=js"
export * from "./UnidadeConservacaoPi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports